const list = {
  path: 'list',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftAlipay/found/list'], resolve)
}

export default list
